import { useOrganizationApi } from '@hooks/api';
import { useGetApi } from '@hooks/api/useGetApi';
import { organizationApiKeys } from '@hooks/api/useOrganizationApi';
import type { GetApiOptions, GetEntity } from 'types/api';
import type { OrganizationProfile } from 'types/organizationProfile';

export function useGetOrganizationProfile(
  { id = '' }: GetEntity,
  options?: Partial<GetApiOptions<OrganizationProfile>>
) {
  const api = useOrganizationApi();
  const result = useGetApi({
    enabled: !!id,
    queryKey: organizationApiKeys.getProfile(id),
    request: () => api.getProfile(id),
    ...options,
  });

  return {
    ...result,
    organization: result.data,
    organizationId: result.data?.id,
    organizationNameId: result.data?.nameId,
  };
}
